// Print / No receipt, chosen on the Fashion payment screen and remembered per
// till on this device. Only the paper print is skipped: the bill is saved and
// synced exactly as before, and the sale-done screen can still print it.
import { isFashionLayout } from "./layout";

export const RECEIPT_CHOICES = Object.freeze({ PRINT: "print", NONE: "none" });

export const receiptChoiceKey = (tillData) => `cw.fashion.receipt.${tillData?.tillAccess?.cwrTill?.cwrTillID || "till"}`;

export function readReceiptChoice(tillData) {
  try {
    return localStorage.getItem(receiptChoiceKey(tillData)) === RECEIPT_CHOICES.NONE ? RECEIPT_CHOICES.NONE : RECEIPT_CHOICES.PRINT;
  } catch {
    return RECEIPT_CHOICES.PRINT;
  }
}

export function writeReceiptChoice(tillData, choice) {
  try {
    localStorage.setItem(receiptChoiceKey(tillData), choice === RECEIPT_CHOICES.NONE ? RECEIPT_CHOICES.NONE : RECEIPT_CHOICES.PRINT);
  } catch {
    // per-device convenience only; the default is to print
  }
}

// Read by order completion: true only on a Fashion till whose cashier chose No receipt.
export const skipsPaperReceipt = (tillData) => isFashionLayout(tillData) && readReceiptChoice(tillData) === RECEIPT_CHOICES.NONE;
